export const BR1104EventsRecord = [
    /**
     * @event 'Custom_Card_Click'
     */
    {
        eventName: 'Custom_Card_Click',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Custom_Card_Close'
     */
    {
        eventName: 'Custom_Card_Close',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Custom_Card_Close_Confirmation'
     */
    {
        eventName: 'Custom_Card_Close_Confirmation',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Custom_Card_Open'
     */
    {
        eventName: 'Custom_Card_Open',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Custom_Card_Change'
     */
    {
        eventName: 'Custom_Card_Change',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Custom_Card_Dish_decrease_quantity'
     */
    {
        eventName: 'Custom_Card_Dish_decrease_quantity',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Custom_Card_Dish_increase_quantity'
     */
    {
        eventName: 'Custom_Card_Dish_increase_quantity',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
];
